import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type IdleManagerStore } from 'entities/Auth/ui/IdleManager/store/IdleManagerStore'

export class AutoRefreshStore {
  private _time_auto_refresh = 0 // seconds
  private _interval: ReturnType<typeof setInterval> | null = null
  private _user_afk = false

  constructor(private _idleManagerStore: IdleManagerStore, private _entities: IEntitiesStore) {
    this._time_auto_refresh = this._idleManagerStore.expire_time / 3

    makeAutoObservable(this)
  }

  init = () => {
    this._initInterval()
  }

  private _initInterval = () => {
    if (this._interval) clearInterval(this._interval)

    this._interval = setInterval(() => {
      this._entities.authStore.refresh()
    }, this._time_auto_refresh * 1000)
  }

  dispose = () => {
    if (this._interval) clearInterval(this._interval)
    this._user_afk = false
  }

  checkAutoRefresh = (time: number) => {
    const _temp_time_auto_refresh = this._time_auto_refresh - 2

    this._idleManagerStore.debug('CheckTime [AutoRefreshStore]', {
      time,
      _temp_time_auto_refresh,
    })

    if (time >= _temp_time_auto_refresh) {
      if (this._interval) clearInterval(this._interval)
      this.setUserAfk(true)

      this._idleManagerStore.debug('UserAfk [AutoRefreshStore]', this._user_afk)
    }
  }

  setUserAfk = (value: boolean) => {
    this._user_afk = value
  }

  userIsActive = () => {
    if (!this._user_afk) return

    this.setUserAfk(false)

    this._idleManagerStore.debug('UserAfk [AutoRefreshStore]', this._user_afk)

    this._entities.authStore.refresh()
    this._initInterval()
  }
}
